module.exports = function () {
  var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var html = "\n      <div class=\"spring-deployment-overlay ".concat(faction, "\" id=\"spring-deployment-overlay\">\n        <div class=\"status\"></div>\n        <div class=\"controls\"></div>\n        <div class=\"instructions\" id=\"instructions\"></div>\n      </div>\n  ");
  return html;
};